import styled from 'styled-components';

export const Container = styled.div`
  @import url('https://fonts.googleapis.com/css2?family=Poppins&display=swap');

  font-family: 'Poppins', sans-serif !important;

  .row-custom {
    background-color: rgb(53, 65, 83);

    height: 50px;

    display: flex;

    align-items: center;

    color: white;
  }
`;
